import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormField, IFormFieldConfig } from '@luggagehero/shared/interfaces';

import { BaseComponent } from '../../../core';

@Component({
  template: '',
  standalone: false,
})
export abstract class DynamicFormButtonBaseComponent extends BaseComponent implements IFormField {
  private cd = inject(ChangeDetectorRef);

  private _group: FormGroup;
  private _config: IFormFieldConfig;

  get group(): FormGroup {
    return this._group;
  }
  set group(value: FormGroup) {
    this._group = value;
    this.cd.markForCheck();
  }

  get config(): IFormFieldConfig {
    return this._config;
  }
  set config(value: IFormFieldConfig) {
    this._config = value;
    this.cd.markForCheck();
  }
}
